import axios from "axios";
import { getRealmApiUrl } from "@/constants/navigation";
import { API_ROUTES } from "@/constants/apiRoutes";
import {
  getRealmRefreshToken,
  storeRealmTokenResponse,
} from "@/services/realmTokenStorage";
import { FORM_HTTP_HEADERS } from "@/services/httpHeaders";
import { createRealmRefreshGrantPayload } from "@/services/iamPayloads";
import type { TokenResponse } from "@/types";

export async function refreshRealmAccessToken(
  realmUuid: string,
  domain: string,
): Promise<string | null> {
  const refreshToken = getRealmRefreshToken(realmUuid);
  if (!refreshToken) return null;

  try {
    const { data } = await axios.post<TokenResponse>(
      getRealmApiUrl(domain, API_ROUTES.iam.token),
      createRealmRefreshGrantPayload(refreshToken),
      { headers: FORM_HTTP_HEADERS },
    );
    return storeRealmTokenResponse(realmUuid, data);
  } catch {
    return null;
  }
}